import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/trader/[address]/page.tsx");
